import { partial } from '../../util/translation/translation';
import moment from 'moment';
import clubConfig from '../../config';

const validatePaymentOptionForm = (values) => {
  const p = partial('validateErrors');
  const errors = {};

  if (
    values.paymentType === 'subscription' &&
    (isNaN(Number(values.optionValue)) || values.optionValue <= 0)
  ) {
    errors.optionValue = `${p('enterCorrectMonths')}`;
  }
  // Sales must end before a fixed membership end date, or buyers get a
  // membership that has already ended
  if (
    values.salesEndDate &&
    values.optionType?.value === 'till_date' &&
    values.optionValue &&
    moment(values.salesEndDate).startOf('day').isAfter(values.optionValue)
  ) {
    errors.salesEndDate = `${p('salesEndAfterDueDate')}`;
  }
  const clubVat = clubConfig.vat || 0;

  if (values.netPrice <= (5 * 100) / (100 + clubVat)) {
    errors.netPrice = `${p('enterCorrectPrice')}`;
  }

  return errors;
};

export default validatePaymentOptionForm;
